
import {AdvancedDynamicTexture, Button, CheckboxGroup, Control, SelectionPanel, SliderGroup} from "@babylonjs/gui/2D";

import OnScreen from "onscreen";

import FullscreenIcon from "./baseline_fullscreen_yellow_24dp.png";
import SettingsIcon from "./baseline_settings_yellow_24dp.png";

function isFullscreen() {
    if (document.fullscreen !== undefined) {
        return document.fullscreen;
        } else if (document.mozFullScreen !== undefined) {
        return document.mozFullScreen;
        } else if (document.webkitIsFullScreen !== undefined) {
        return document.webkitIsFullScreen;
        } else if (document.msIsFullScreen !== undefined) {
        return document.msIsFullScreen;
        }
    return false;
    }

class SceneGUI {
    constructor(world) {
        this.world = world;
        this.fgColor = "yellow";

        const t = world.translation;

        var advancedTexture = new AdvancedDynamicTexture.CreateFullscreenUI("myUI", true);
        this.advancedTexture = advancedTexture;

        var button = Button.CreateImageOnlyButton("button", FullscreenIcon);

        var checkboxGroup = new CheckboxGroup(t("Switches"));
        checkboxGroup.addCheckbox(t("Labeled"), world.updateLabeled);
        checkboxGroup.addCheckbox(t("Auto Rotate"), world.updateAutoRotate);
        this.checkboxGroup = checkboxGroup;

        var button2 = Button.CreateImageOnlyButton("button2", SettingsIcon);
        button2.width="40px";
        button2.height="40px";
        button2.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        button2.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_RIGHT;
        button2.color = this.fgColor;
        button2.paddingTop = "10px";
        button2.paddingRight = "10px";
        this.settingsActive = false;

        button2.onPointerDownObservable.add(() => {
            if (this.settingsActive) {
                //selectionPanel.enabled = false;
                advancedTexture.removeControl(this.selectionPanel);
                this.settingsActive = false;
                } else {
                advancedTexture.addControl(this.selectionPanel);
                this.settingsActive = true;
                }
            });

        button.width="40px";
        button.height="40px";
        button.verticalAlignment = Control.VERTICAL_ALIGNMENT_BOTTOM;
        button.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_RIGHT;
        button.color = this.fgColor;
        button.paddingBottom = "10px";
        button.paddingRight = "10px";

        button.onPointerDownObservable.add(() => {
            if (isFullscreen()) {
                if (this.settingsActive) {
                    advancedTexture.removeControl(this.selectionPanel);
                    this.settingsActive = false;
                    }
                advancedTexture.removeControl(button2);
                world.engine.exitFullscreen();
                world.setFullscreen(false);

                } else {

                advancedTexture.addControl(button2);
                world.toFullscreen();
                }
            });
        advancedTexture.addControl(button);

        document.addEventListener("fullscreenchange",() => {
                if (!isFullscreen()) {

                    if (this.settingsActive) {
                        advancedTexture.removeControl(this.selectionPanel);
                        this.settingsActive = false;
                        }
                    advancedTexture.removeControl(button2);
                    world.setFullscreen(false);
                    }
                });
        }
    updateGUI = (cMax, yMax) => {
        const t = this.world.translation;

        var sliderGroup = new SliderGroup(t("Settings"));
        sliderGroup.color = "white"; // this.fgColor;
        sliderGroup.textColor = this.fgColor;
        sliderGroup.headerColor = this.fgColor;
        sliderGroup.labelColor = "white";

        if (cMax > 1) {
            sliderGroup.addSlider(t("Container"), this.world.updateContainer, 0, 0, cMax + 1, this.displayValue);
            }
        sliderGroup.addSlider(t("Level"), this.world.updateLevel, 0, 0, yMax, this.displayValue);


        var selectionPanel = new SelectionPanel("selectionPanel", [sliderGroup, this.checkboxGroup]);
        selectionPanel.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
        selectionPanel.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        selectionPanel.width = "300px";
        selectionPanel.height = "300px";
        selectionPanel.color= "black";
        selectionPanel.headerColor = this.fgColor;
        selectionPanel.barColor = "white"; // this.fgColor;
        // selectionPanel.buttonColor = "white";
        selectionPanel.labelColor = "white";
        selectionPanel.paddingLeft = "10px";
        selectionPanel.paddingTop = "10px";

        this.selectionPanel = selectionPanel;
        }

    displayValue = (value) => {
        return str(value);
        }

    }

export default SceneGUI;